export default "__VITE_ASSET__u7DF5G2O__"